const prefix = 'FINANCIAL_';

export const FinancialActionTypes = {
  RESET_ORDER_ITEMS: `${prefix}RESET_ORDER_ITEMS`,
  SET_ORDER_ID: `${prefix}SET_ORDER_ID`,
  GET_ORDER_ITEM: `${prefix}GET_ORDER_ITEM`,
  SET_ORDER_ITEM: `${prefix}SET_ORDER_ITEM`,
  SET_SELECTED_GATEWAY: `${prefix}SET_SELECTED_GATEWAY`,
  SET_SELECTED_WALLET: `${prefix}SET_SELECTED_WALLET`,
  SET_DISCOUNT_CODE: `${prefix}SET_DISCOUNT_CODE`,
  SET_DISCOUNT_MODAL: `${prefix}SET_DISCOUNT_MODAL`,
  GET_CODE_VALIDATION: `${prefix}GET_CODE_VALIDATION`,
  SET_DISCOUNT_VALIDATION: `${prefix}SET_DISCOUNT_VALIDATION`,
  SET_ORDER_PAYMENT: `${prefix}SET_ORDER_PAYMENT`,
  SET_ORDER_LOADING: `${prefix}SET_ORDER_LOADING`,
  DELETE_DISCOUNT_CODE: `${prefix}DELETE_DISCOUNT_CODE`,
  SET_RECEIPT_FILE: `${prefix}SET_RECEIPT_FILE`,
  SEND_CARD_TO_CARD_RECEIPT_ORDER: `${prefix}SEND_CARD_TO_CARD_RECEIPT_ORDER`,
  SET_IS_UPLOADED_RECEIPT: `${prefix}SET_IS_UPLOADED_RECEIPT`,
  HANDLE_CANCEL_ORDER: `${prefix}HANDLE_CANCEL_ORDER`,
  SET_CANCEL_ORDER_LOADING: `${prefix}SET_CANCEL_ORDER_LOADING`,
  SET_IS_SHOP: `${prefix}SET_IS_SHOP`,
  SET_PHARMACY_DESCRIPTION: `${prefix}SET_PHARMACY_DESCRIPTION`,
  GET_VALID_DISCOUNT_CODES: `${prefix}GET_VALID_DISCOUNT_CODES`,
  SET_VALID_DISCOUNT_CODES: `${prefix}SET_VALID_DISCOUNT_CODES`,
};

const resetOrderItems = () => ({ type: FinancialActionTypes.RESET_ORDER_ITEMS });
const setOrderId = (data: { orderItemId: string }) => ({ type: FinancialActionTypes.SET_ORDER_ID, data: data });
const getOrderItem = (data: { orderItemId: string }) => ({ type: FinancialActionTypes.GET_ORDER_ITEM, data: data });
const setSelectedGateway = (data: { selectedGateway: string }) => ({ type: FinancialActionTypes.SET_SELECTED_GATEWAY, data: data });
const setWalletSelect = (data: { walletSelected: boolean }) => ({ type: FinancialActionTypes.SET_SELECTED_WALLET, data: data });
const setDiscountCode = (data: { discountCode: string }) => ({ type: FinancialActionTypes.SET_DISCOUNT_CODE, data: data });
const setDiscountModal = (data: { discountCodeModal: boolean }) => ({ type: FinancialActionTypes.SET_DISCOUNT_MODAL, data: data });
const getCodeValidation = () => ({ type: FinancialActionTypes.GET_CODE_VALIDATION });
const sendPaymentOrder = () => ({ type: FinancialActionTypes.SET_ORDER_PAYMENT });
const deleteDiscountCode = () => ({ type: FinancialActionTypes.DELETE_DISCOUNT_CODE });
const setOrderLoading = (data: { paymentLoading: boolean }) => ({ type: FinancialActionTypes.SET_ORDER_LOADING, data: data });
const setCardToCardReceiptFile = (data: { receiptFile: any }) => ({ type: FinancialActionTypes.SET_RECEIPT_FILE, data: data });
const sendCardToCardReceiptOrder = () => ({ type: FinancialActionTypes.SEND_CARD_TO_CARD_RECEIPT_ORDER });
const handleCancelOrder = (data: {reasonId: number}) => ({ type: FinancialActionTypes.HANDLE_CANCEL_ORDER, data: data });
const setIsShop = () => ({ type: FinancialActionTypes.SET_IS_SHOP });
const pharmacyDescription = (data: {description: string}) => ({ type: FinancialActionTypes.SET_PHARMACY_DESCRIPTION, data: data });
const getValidDiscountCodes = () => ({ type: FinancialActionTypes.GET_VALID_DISCOUNT_CODES });

export const FinancialAction = {
  setOrderId: setOrderId,
  getOrderItem: getOrderItem,
  setSelectedGateway: setSelectedGateway,
  setWalletSelect: setWalletSelect,
  setDiscountCode: setDiscountCode,
  setDiscountModal: setDiscountModal,
  getCodeValidation: getCodeValidation,
  sendPaymentOrder: sendPaymentOrder,
  resetOrderItems: resetOrderItems,
  deleteDiscountCode: deleteDiscountCode,
  setOrderLoading: setOrderLoading,
  setCardToCardReceiptFile: setCardToCardReceiptFile,
  sendCardToCardReceiptOrder: sendCardToCardReceiptOrder,
  handleCancelOrder: handleCancelOrder,
  setIsShop: setIsShop,
  pharmacyDescription: pharmacyDescription,
  getValidDiscountCodes: getValidDiscountCodes,
};
